export default "__VITE_ASSET__CQQgQhLB__"